<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('motivos-visita') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('promotor') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('motivos-visita') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'motivo-visita-new' })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="changeSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allmotivosvisita"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir' && permissao.update">
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>

                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'motivo-visita-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import MotivoVisitaService from '@/services/promotor/MotivoVisitaService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('motivo-visita') && to.name != 'motivo-visita-list') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            allmotivosvisita: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new MotivoVisitaService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: null, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            deleteThis: {},
            debouncedOnSearch: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'visitreasons');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'motivos-visita' },
            });
            return;
        }

        this.rotaAninhada =
            this.$route.name.includes('motivo-visita') && this.$route.name != 'motivo-visita-list';

        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.searchQuery
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allmotivosvisita = value;
                    this.isEmpty = this.allmotivosvisita.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        changeSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let motivovisitalist = [];
            if (body.content) {
                motivovisitalist = body.content.map((mv) => {
                    return {
                        id: mv.idmotivovisita,
                        codigo: mv.idmotivovisitaerp,
                        descricao: mv.descricao,
                        excluir: 'excluir',
                        situacao: mv.situacao,
                    };
                });
            }
            return motivovisitalist;
        },
        promptChangeSituacao(row) {
            this.deleteThis = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.deleteThis = null;
        },
        updateSituacao() {
            let motivovisita = {
                idmotivovisita: this.deleteThis.id,
                situacao: this.deleteThis.situacao == 1 ? 0 : 1,
            };

            this.service
                .updateSituacao(motivovisita)
                .then((r) => {
                    if (r.status == 200) {
                        let messageSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-desativar'
                                    : 'msg-sucesso-ao-reativar', 
                                { n: this.$t('motivo-visita') }
                            );

                        this.$root.showMessage('success', messageSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);

                    let messageFail = this.$t(
                            this.deleteThis.situacao == 1
                                ? 'msg-erro-ao-desativar'
                                : 'msg-erro-ao-reativar', 
                            { n: this.$t('motivo-visita') }
                        );

                    this.$root.showMessage('error', messageFail, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.deleteThis = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0px 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .situacao-select div {
            height: 40px;
        }
    }
}
</style>
